import React from "react";

const SpecialDoctors = () => {
  return (
    <div className="row">
      <div className="col-md-12 col-sm-12 col-12">
        <h2>Specialist Visits</h2>
      </div>
      <div className="col-lg-4 col-md-6 col-sm-12 col-12 mt-4">
        <div className="card">
          <div className="card-body bg-light">
            <div className="list-heading-one pt-3"> Cardiologist</div>
            <div className="list-hr" />
            <div className="list-doctorName pt-3">
              Dr. Velam Vanajakshamma M.D., D.M.
            </div>
            <p className="pt-3">Cardiologist From SVIMS, Tirupati</p>
          </div>
        </div>
      </div>
      {/* <div className="col-lg-4 col-md-6 col-sm-12 col-12 mt-4">
        <div className="card">
          <div className="card-body bg-light">
            <div className="list-heading-one pt-3"> Neurologist</div>
            <div className="list-hr" />
            <div className="list-doctorName pt-3">
              Dr. Sunita Asula M.D., D.M.
            </div>
            <p className="pt-3"> Neurologist From Kurnool</p>
          </div>
        </div>
      </div> */}
      <div className="col-lg-4 col-md-6 col-sm-12 col-12 mt-4">
        <div className="card">
          <div className="card-body bg-light">
            <div className="list-heading-one pt-3">
              Surgical Gastroenterologist
            </div>
            <div className="list-hr" />
            <div className="list-doctorName pt-3">
              Dr. Nara Bharat Kumar M.C.H
            </div>
            <p className="pt-3">Surgical Gastroenterologist</p>
          </div>
        </div>
      </div>
      <div className="col-lg-4 col-md-6 col-sm-12 col-12 mt-4">
        <div className="card">
          <div className="card-body bg-light">
            <div className="list-heading-one pt-3"> Ophthalmologist</div>
            <div className="list-hr" />
            <div className="list-doctorName pt-3">Dr. Srinivasa Satry M.S.</div>
            <p className="pt-3"> Ophthalmologist</p>
          </div>
        </div>
      </div>
      {/* <div className="col-lg-4 col-md-6 col-sm-12 col-12 mt-4">
        <div className="card">
          <div className="card-body bg-light">
            <div className="list-heading-one pt-3"> ENT</div>
            <div className="list-hr" />
            <div className="list-doctorName pt-3">Dr. Durgamba M.S.</div>
            <p className="pt-3"> ENT</p>
          </div>
        </div>
      </div> */}
      <div className="col-lg-4 col-md-6 col-sm-12 col-12 mt-4">
        <div className="card">
          <div className="card-body bg-light">
            <div className="list-heading-one pt-3"> Orthopedician</div>
            <div className="list-hr" />
            <div className="list-doctorName pt-3">Dr. Manish Kulkarni M.S.</div>
            <p className="pt-3"> Orthopedician</p>
          </div>
        </div>
      </div>
      <div className="col-lg-4 col-md-6 col-sm-12 col-12 mt-4">
        <div className="card">
          <div className="card-body bg-light">
            <div className="list-heading-one pt-3"> Pulmonology</div>
            <div className="list-hr" />
            <div className="list-doctorName pt-3">Dr. Narendra, MD</div>
            <p className="pt-3"> Pulmonology</p>
          </div>
        </div>
      </div>
      <div className="col-lg-4 col-md-6 col-sm-12 col-12 mt-4">
        <div className="card">
          <div className="card-body bg-light">
            <div className="list-heading-one pt-3"> Gynaecology</div>
            <div className="list-hr" />
            <div className="list-doctorName pt-3">Dr. Meenakshi MD</div>
            <p className="pt-3"> Gynaecology</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SpecialDoctors;
